import { useEffect } from 'react';

import { useReactNodeView } from '@lyearn/lygo-core';
import { Uppy } from '@lyearn/shared/hooks/useUppy';
import { useSnackbar } from '@lyearn/ui';

import { isLocalUrl, validatedSrc } from '../utils/upload';
import useHandleUpload from './useHandleUpload';
import useUpload from './useUpload';

const EMPTY_OBJECT: Record<string, string> = {};
const Base64MediaSource = 'Base64Upload';

const useBase64Media = (
  uppy: Uppy | null,
  currentFile: ReturnType<typeof useUpload>['currentFile'],
  node?: ReturnType<typeof useReactNodeView>['node'],
) => {
  const { showErrorSnackbar } = useSnackbar();
  const { src, id } = node?.attrs || EMPTY_OBJECT;
  const handleUpload = useHandleUpload();

  useEffect(() => {
    const isUploading = currentFile?.id;
    if (!validatedSrc(src) || isUploading || !isLocalUrl(src)) {
      return;
    }

    handleUpload(
      fetch(src)
        .then((res) => res.blob())
        .then(
          (blob) =>
            uppy?.addFile({
              source: Base64MediaSource,
              name: id,
              type: blob.type,
              data: blob,
              meta: { shortId: id },
            }),
        ),
    );
  }, [currentFile, handleUpload, id, showErrorSnackbar, src, uppy]);
};

export default useBase64Media;
